module.exports = __webpack_public_path__ + "static/img/five.bcb9c404.png";